import { render, staticRenderFns } from "./ActionLink.vue?vue&type=template&id=07c5067c"
import script from "./ActionLink.vue?vue&type=script&lang=ts"
export * from "./ActionLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports